import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { LoaderButtonType } from '../../models/loader-button-type.enum';
import { HtmlButtonType } from '../../models/html-button-type.enum';

@Component({
standalone: false,
  selector: 'app-new-loader-button',
  styleUrls: ['./new-loader-button.component.scss'],
  templateUrl: './new-loader-button.component.html',
})
export class NewLoaderButtonComponent {
  private _style: any;

  private _customType: LoaderButtonType = LoaderButtonType.STANDARD;

  @Input()
  public set customType(newType: LoaderButtonType) {
    if (newType) {
      this._customType = newType;
    }
  }


  @Input() public buttonType: HtmlButtonType = HtmlButtonType.BUTTON;
  @Input() public color: ThemePalette = undefined;
  @Input() public disabled: boolean;
  @Input() public loading: boolean;
  @Input() public billtechPayMode: boolean;

  @Input()
  public set style(style: any) {
    if (style) {
      this._style = style;
    }
  }

  @Output() public buttonClick = new EventEmitter<any>();

  public loaderButtonType = LoaderButtonType;

  public onButtonClick(e): void {
    this.buttonClick.emit(e);
  }

  public get style(): any {
    if (this._style) {
      return this._style;
    } else {
      return {};
    }
  }

  get customType(): LoaderButtonType{
    return this._customType;
  }
}
